import React from 'react'
import { LinkButton } from '@/atoms/Button'
import { GiftIcon } from '@/atoms/Icons/GiftIcon'
import { ParagraphSM, TitleSM } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useTranslate } from '@/utils/translate/translate-client'

interface GiftTheGuildSectionProps {
  onClick?: () => void
}

export const GiftTheGuildSection: React.FC<GiftTheGuildSectionProps> = ({ onClick }) => {
  const { t } = useTranslate('guild')

  return (
    <div className="rounded-lg border border-core-gray-200 bg-core-gray-100 p-6 lg:p-12">
      <div className="flex w-full flex-col gap-4 md:gap-6">
        <div className="flex items-center gap-3 align-middle">
          <div className="flex h-10 w-10 items-center justify-center rounded-3xl bg-oxide-primary align-middle">
            <GiftIcon color="white" className="m-auto" size={22} />
          </div>
          <TitleSM weight="bold" className="md:photon-title-md lg:photon-title-lg" color="core-gray-950">
            {t('giftTheGuild', 'Gift the Guild')}
          </TitleSM>
        </div>
        <ParagraphSM className="md:photon-title-md text-pretty" color="core-gray-800" weight="medium">
          {t(
            'giftTheGuildDescription',
            'Share the gift of Angel Guild membership with friends and family. Give them access to a growing library of high-quality, uplifting entertainment.',
          )}
        </ParagraphSM>
        <div className="grid grid-cols-2 gap-8 align-middle">
          <LinkButton
            className="w-fit border-0 bg-oxide-primary"
            href={paths.guild.gift.index}
            onClick={onClick}
            variant={'oxide'}
            prefetch={false}
          >
            <div className="mx-auto whitespace-nowrap text-center">{t('giftTheGuild', 'Gift the Guild')}</div>
          </LinkButton>
        </div>
      </div>
    </div>
  )
}
